module.exports = __webpack_public_path__ + "img/logo-color.d1477ecc.svg";